import { Toast } from "antd-mobile";

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  500: "服务器发生错误，请检查服务器。",
};

const errorHandler = async (response) => {
  if (response.status) {
    let errorText = codeMessage[response.status] || response.statusText;
    const res = await response.json();
    errorText = res.msg ? res.msg : errorText;
    Toast.show({
      icon: "fail",
      content: errorText,
    });
  } else {
    Toast.show({
      icon: "fail",
      content: "您的网络发生异常，无法连接服务器",
    });
  }
};

const request = async (url, options) => {
  const response = await fetch(url, options);
  if (!response.ok) {
    await errorHandler(response);
    throw new Error("Request failed");
  }
  return response.json();
};

const buildRequestOptions = (method: string, data?: any) => {
  const token = localStorage.getItem("tokens") || " ";

  const headers = {
    "tenant-id": "103",
    Authorization: `Bearer ${token}`,
    // 'Content-Type': 'application/json', // 如果需要传递JSON数据
  };

  const options: any = {
    method,
    headers,
    credentials: "include",
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  return options;
};

export const get = async (url, parameter) => {
  return await request(
    `${process.env.REQUEST_SERVER_URL}${url}`,
    buildRequestOptions("GET")
  );
};

export const post = async (url, parameter) => {
  return await request(
    `${process.env.REQUEST_SERVER_URL}${url}`,
    buildRequestOptions("POST", parameter)
  );
};

export const upload = async (url, parameter) => {
  const formData = new FormData();
  for (const key in parameter) {
    formData.append(key, parameter[key]);
  }
  return await request(`${process.env.REQUEST_SERVER_URL}${url}`, {
    ...buildRequestOptions("POST"),
    body: formData,
  });
};

export const deletes = async (url, parameter) => {
  return await request(
    `${process.env.REQUEST_SERVER_URL}${url}`,
    buildRequestOptions("DELETE", parameter)
  );
};

export const put = async (url, parameter) => {
  return await request(
    `${process.env.REQUEST_SERVER_URL}${url}`,
    buildRequestOptions("PUT", parameter)
  );
};

export default {
  get,
  post,
  put,
  deletes,
  upload,
};
